export enum ViewSourceEnum {
    Feed = 'feed',
    Explore = 'suggestion',
    Activity = 'activity',
    Detail = 'detail'
}  